import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './PendingMemberItem.m.sass';
var pendingMember = function pendingMember(_ref) {
  var pendingMember = _ref.pendingMember;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.avatarContainer
  }, /*#__PURE__*/React.createElement(AvatarGenerator, {
    letter: pendingMember.email[0],
    id: pendingMember.id
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.subtitle
  }, pendingMember.email), /*#__PURE__*/React.createElement("p", {
    className: styles.pendingTag
  }, "Pending")));
};
export default observer(pendingMember);
var AvatarGenerator = function AvatarGenerator(_ref2) {
  var letter = _ref2.letter,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? 3 : _ref2$id;
  var colors = ['#1abc9c', '#2ecc71', '#3498db', '#9b59b6', '#34495e', '#16a085', '#27ae60', '#95a5a6', '#f39c12', '#d35400', '#c0392b', '#bdc3c7', '#7f8c8d'];
  var backgroundColor = colors[(colors.length - 1) % id];
  return /*#__PURE__*/React.createElement("div", {
    className: styles.avatar,
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.avatarText
  }, letter));
};
//# sourceMappingURL=index.js.map
